import en from './en';
import es from './es';
import pt from './pt';

export default {
    en,
    es,
    pt
};
